import React from 'react';
import PropTypes from 'prop-types';
import GoogleAnalytics from 'react-ga';
import { connect } from 'react-redux';
import { CSSTransition } from 'react-transition-group';
import { starCalculator } from '../../../helpers/starCalculator';
import { randomCongrats } from '../../../helpers/randomCongrats';
import RoundResultsStyled, {
  Title,
  ResultDefList,
  ResultDD,
  ResultDT,
} from './RoundResults.styled';
import GameArticleStars from '../../atoms/GameArticleStars/GameArticleStars';
import EndGameOptions from '../../molecules/EndGameOptions/EndGameOptions';
import ResultIcon from '../../atoms/ResultIcon/ResultIcon';
import { splitAndSpanString } from '../../../helpers/splitAndSpanString';
import { ShareButtonWrap } from '../../atoms/ShareButton/ShareButton.styled';
import ShareButton from '../../atoms/ShareButton/ShareButton';

const mapStateToProps = state => ({
  moveCount: state.game.moveCount,
  roundWin: state.game.roundWin,
  initTime: state.gameData[state.saved.level].time,
  timeTaken: state.gameData[state.saved.level].time - state.game.time,
  timeTotal: state.game.timeTaken,
  savedTimeTaken: state.saved.best[state.saved.level].timeTaken
    ? state.saved.best[state.saved.level].timeTaken
    : 0,
  savedMoveCount: state.saved.best[state.saved.level].moveCount
    ? state.saved.best[state.saved.level].moveCount
    : 0,
  savedStarCount: state.saved.best[state.saved.level].starCount
    ? state.saved.best[state.saved.level].starCount
    : 0,
  level: state.saved.level,
  countUp: state.settings.countUp,
  countDown: state.settings.countDown,
});

const RoundResults = ({
  show,
  level,
  moveCount,
  initTime,
  timeTaken,
  timeTotal,
  savedTimeTaken,
  savedMoveCount,
  roundWin,
  countUp,
  countDown,
}) => {
  const time = countDown ? timeTaken : countUp ? timeTotal : '-';
  return (
    <CSSTransition in={show} appear timeout={400} classNames="result">
      <section className="result">
        <RoundResultsStyled show={show}>
          <ResultIcon win />
          <GameArticleStars
            roundResult
            stars={starCalculator(initTime, time, moveCount)}
          />
          <Title>{splitAndSpanString(randomCongrats())}</Title>
          <ResultDefList>
            <ResultDT>Moves</ResultDT>
            <ResultDD>{moveCount}</ResultDD>
            {<ResultDD PB>{savedMoveCount}</ResultDD>}
            <ResultDT>Time</ResultDT>
            <ResultDD>{time}s</ResultDD>
            {<ResultDD PB>{savedTimeTaken}s</ResultDD>}
          </ResultDefList>
          <ShareButtonWrap>
            <ShareButton
              type="twitter"
              result={{ level, time, moveCount, roundWin }}
            />
            <ShareButton type="facebook" />
          </ShareButtonWrap>
          <EndGameOptions roundWin={roundWin} show={show} />
        </RoundResultsStyled>
        {GoogleAnalytics.event({
          category: 'Gameplay',
          action: `User Completed Puzzle: ${level + 1}`,
          label: `Round Won: `,
          value: level + 1,
        })}
      </section>
    </CSSTransition>
  );
};

export default connect(mapStateToProps)(RoundResults);

RoundResults.propTypes = {
  countDown: PropTypes.bool.isRequired,
  countUp: PropTypes.bool.isRequired,
  level: PropTypes.number.isRequired,
  show: PropTypes.bool,
  roundWin: PropTypes.bool.isRequired,
  moveCount: PropTypes.number.isRequired,
  initTime: PropTypes.number.isRequired,
  timeTaken: PropTypes.number,
  timeTotal: PropTypes.number,
  savedTimeTaken: PropTypes.number.isRequired,
  savedMoveCount: PropTypes.number.isRequired,
};

RoundResults.defaultProps = {
  show: false,
  timeTaken: 0,
  timeTotal: 0,
};



// WEBPACK FOOTER //
// ./src/components/organisms/RoundResults/RoundResults.js